import { SectionVM, TrascrizioneUnioneCivile } from 'civil-status/view-models/step-form';

export const transformerTrascrizioneUnioneCivile = (
  idEvento?: number,
  dataSection?: SectionVM
): TrascrizioneUnioneCivile | undefined => {
  if (!dataSection) {
    return undefined;
  }

  return {
    key: {
      idEvento,
    },
    dataComunicazione: dataSection.dateTranscription
      ? dataSection.dateTranscription.toFormat('yyyy-MM-dd')
      : undefined,
    trascrizione: dataSection?.templateTranscriptionText || undefined,
    dichiarazione: dataSection?.typeRequest || undefined,
    tipoTrascrizione: dataSection?.typeActToTranscribed || undefined,
  };
};
